export default "__VITE_ASSET__CzQbck5Q__"